import { IHoSoSinhVienViewModel } from "../../../model/response/category/IHoSoSinhVienViewModel";
import { ITraCuuDiemResponse } from "../../../model/response/tra-cuu-diem/ITraCuuDiemResponse";
import { ITraCuuDiemSinhVienReducer } from "../../reducer-model/tra-cuu-diem/ITraCuuDiemReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface ITraCuuDiemActionsTypeBase<T> {
    id: string;
    data: T;
}
export const eTraCuuDiemActionsObj = {
    ADD_NEW_TAB: {} as undefined | IHoSoSinhVienViewModel,
    REMOVE_TAB: "",
    UPDATE_TAB_DATA: {} as ITraCuuDiemSinhVienReducer,
    CHANGE_SELECTED_TAB: "",

    LOAD_TRA_CUU_DIEM_START: {} as ITraCuuDiemActionsTypeBase<string>,
    LOAD_TRA_CUU_DIEM_SUCCESS: {} as ITraCuuDiemActionsTypeBase<ITraCuuDiemResponse>,
    LOAD_TRA_CUU_DIEM_ERROR: {} as ITraCuuDiemActionsTypeBase<string>,

    CHANGE_SELECTED_DIEM_THI: {} as ITraCuuDiemActionsTypeBase<number>,
    CHANGE_SELECTED_DIEM: {} as ITraCuuDiemActionsTypeBase<number>,

    CHANGE_IS_HIEN_THI_BANG_THANH_PHAN: {} as boolean,
}

export const eTraCuuDiemActionIds  = generateActionTypeIds(eTraCuuDiemActionsObj , "TRA_CUU_DIEM");
export type ITraCuuDiemActionsType = IGenericActionType<typeof eTraCuuDiemActionsObj, "TRA_CUU_DIEM">;